import { render, staticRenderFns } from "./CustomerActivityNote.vue?vue&type=template&id=631657f2&"
import script from "./CustomerActivityNote.vue?vue&type=script&lang=js&"
export * from "./CustomerActivityNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports